import React, { Component } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'

class ClaimItemsList extends Component {
  columns = [
    {
      Header: 'ID',
      accessor: 'no',
      Cell: ({ original, value }) => {
        return <a onClick={(e) => this.props.onShowClaimItem(e, original, 'edit')}>{value}</a>
      },
    },
    {
      Header: 'Vendor',
      accessor: 'vendor',
    },
    {
      Header: 'Currency',
      accessor: 'currency.code',
    },
    {
      Header: 'Method',
      accessor: 'method',
    },

    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: MoneyCell,
    },
  ]

  render() {
    const { onShowClaimItem, claimItemList, fetchingClaim, claim } = this.props
    return (
      <CustomTable
        CreateButton={() =>
          claim.status !== 'Approved' && claim.status !== 'Rejected' ? (
            <Button type={'primary'} size={'small'} icon={'plus'} onClick={onShowClaimItem}>
              New{' '}
            </Button>
          ) : null
        }
        hide={{ refresh: true }}
        columns={this.columns}
        loading={fetchingClaim}
        data={claimItemList}
      />
    )
  }
}

ClaimItemsList.propTypes = {}
ClaimItemsList.defaultProps = {}

export default ClaimItemsList
